var globals = {
  REACT_APP_APIROOT_AUTO: process.env.REACT_APP_APIROOT_AUTO,
  REACT_APP_APIADRESS: process.env.REACT_APP_APIADRESS,
  REACT_APP_RECAPTCHA_KEY: process.env.REACT_APP_RECAPTCHA_KEY,
  REACT_APP_PORTAL_AUTO: process.env.REACT_APP_PORTAL_AUTO,
};

export default globals;
